import {
  MenuItemBasicWithSides,
  MenuOptionGroupBasicWithItems,
} from "client/jspPlatformExperiment";
import { isMenuSectionBasicWithItems } from "models/menu/menu";
import { v4 as uuidv4 } from "uuid";
import {
  DisplayMenuItem,
  DisplayMenuSection,
} from "models/menu/menuContentsReducer";

export function getDisplayMenuOptionGroup(
  optionGroupData: MenuOptionGroupBasicWithItems,
): DisplayMenuSection {
  return {
    ...optionGroupData,
    options: Object.fromEntries(
      optionGroupData.options.map((option) => {
        let displayOption: DisplayMenuItem | DisplayMenuSection;
        if (isMenuSectionBasicWithItems(option)) {
          displayOption = getDisplayMenuOptionGroup(option);
        } else {
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          displayOption = getDisplayMenuItem(option);
        }

        return [uuidv4(), displayOption];
      }),
    ),
  };
}

export function getDisplayMenuItem(
  menuItemData: MenuItemBasicWithSides,
): DisplayMenuItem {
  return {
    ...menuItemData,
    side_option_groups: Object.fromEntries(
      (menuItemData.side_option_groups ?? []).map((sideOptGroup) => [
        uuidv4(),
        getDisplayMenuOptionGroup(sideOptGroup),
      ]),
    ),
  };
}
